import React, { useState, useEffect } from "react";
import axios from "../axios/axios";
import { Box, Stack, Wrap, WrapItem } from "@chakra-ui/react";

import UserListHStack from "../components/UserListHStack";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";

export default function AdminUsersContainer() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios
      .get("/users")
      .then(response => {
        setUsers(response.data);
      })
      .catch(error => {
        console.error("Error fetching users:", error);
      });
  }, []);

  return (
    <Box width={"full"} ml={{ base: 0, md: "20px" }} px={{ base: 2, md: 0 }}>
      <Header fontSize={{ base: "xl", md: "2xl" }}>Collaborateurs</Header>
      <Stack direction={{ base: "column", md: "row" }} spacing={{ base: 4, md: 6 }}>
        <Wrap spacing={{ base: 2, md: 3 }} mt={{ base: 4, md: 6 }} justify={{ base: "center", md: "flex-start" }}>
          {users.length > 0 ? (
            users.map(user => (
              <WrapItem key={user.id} width={{ base: "full", sm: "auto" }}>
                <UserListHStack user={user} as={Link} to={`/admin/users/${user.id}`} width={{ base: "full", sm: "auto" }} />
              </WrapItem>
            ))
          ) : (
            <>
              <WrapItem width={{ base: "full", sm: "auto" }}>
                <UserListHStack />
              </WrapItem>
              <WrapItem width={{ base: "full", sm: "auto" }}>
                <UserListHStack />
              </WrapItem>
              <WrapItem width={{ base: "full", sm: "auto" }}>
                <UserListHStack />
              </WrapItem>
            </>
          )}
        </Wrap>
      </Stack>
    </Box>
  );
}
